<template>
    <div>
        <div class="page-content">
            <div class="container-fluid">

                <!-- start page title -->
                <div class="row">
                    <div class="col-12">
                        <div class="page-title-box d-flex align-items-center justify-content-between">
                            <h4 class="mb-0 font-size-18">Tableau de bord
                            </h4>

                            <div class="page-title-right">
                                <ol class="breadcrumb m-0">
                                    <li class="breadcrumb-item"><a href="javascript: void(0);">Accueil</a></li>
                                    <li class="breadcrumb-item active">Tableau de bord
                                    </li>
                                </ol>
                            </div>

                        </div>
                    </div>
                </div>
                <!-- end page title -->

                <v-carousel
                        cycle
                        height="250"
                        hide-delimiter-background
                        show-arrows-on-hover
                >
                    <v-carousel-item
                            v-for="(slide, i) in slides"
                            :key="i"
                    >
                        <img :src="slide" alt="" width="100%">


                    </v-carousel-item>
                </v-carousel>

                <div class="row">
                    <div class="col-xl-12">
                        <div class="row">
                            <div class="col-md-3">
                                <div class="card mini-stats-wid">
                                    <div class="card-body" style="background-color: #046089">
                                        <div class="media">
                                            <div class="media-body">
                                                <p class="font-weight-medium" style="color: white">Balance</p>
                                                <h4 v-if='user.relation!=null' class="mb-0" style="color: white">XOF {{balance.amount}} </h4>
                                                <h4 v-else class="mb-0" style="color: white">XOF {{balance}} </h4>
                                            </div>

                                            <div class="mini-stat-icon avatar-sm rounded-circle bg-white align-self-center">
                                                        <span class="avatar-title"
                                                              style="background: #00a08c!important">
                                                            <i class="bx bxs-wallet font-size-24"></i>
                                                        </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="card mini-stats-wid">
                                    <div class="card-body" style="background-color: #046089">
                                        <div class="media">
                                            <div class="media-body">
                                                <p class="font-weight-medium" style="color: white">Chiffre d'affaire</p>
                                                <h4 class="mb-0" style="color: white">XOF {{sumvente}} </h4>
                                            </div>

                                            <div class="mini-stat-icon avatar-sm rounded-circle bg-white align-self-center">
                                                        <span class="avatar-title"
                                                              style="background: #00a08c!important">
                                                            <i class="bx bx-money font-size-24"></i>
                                                        </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="card mini-stats-wid">
                                    <div class="card-body" style="background-color: #046089">
                                        <div class="media">
                                            <div class="media-body">
                                                <p class="font-weight-medium" style="color: white">Commandes</p>
                                                <h4 class="mb-0" style="color: white">{{precommandeCount}} </h4>
                                            </div>

                                            <div class="mini-stat-icon avatar-sm rounded-circle bg-white align-self-center">
                                                        <span class="avatar-title"
                                                              style="background: #00a08c!important">
                                                            <i class="bx bx-list-ul font-size-24"></i>
                                                        </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="card mini-stats-wid">
                                    <div class="card-body" style="background-color: #046089">
                                        <div class="media">
                                            <div class="media-body">
                                                <p class="font-weight-medium" style="color: white">Utilisateurs</p>
                                                <h4 class="mb-0" style="color: white"> {{userspharmacies.length}}</h4>
                                            </div>

                                            <div class="mini-stat-icon avatar-sm rounded-circle bg-white align-self-center">
                                                        <span class="avatar-title"
                                                              style="background: #00a08c!important">
                                                            <i class="bx bx-user font-size-24"></i>
                                                        </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div class="row">

                 <v-card
                        class="mx-auto col-md-12"
                        style=""
                        tile
                >
                      <div class="row">
                          <div class="col-12 mb-4">
                              <h2>STATISTIQUES DES VENTES</h2>
                              <p>Ci-dessous l'evolution des différentes ventes effectuées par date</p>
                          </div>
                          <div class="col-12 mb-2">
                              <h4>Filtrer suivant une date</h4>
                          </div>
                                <v-col cols="12" sm="4" class="mb-3">
                                  <v-menu
                                    v-model="menu2"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px" >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-text-field
                                        v-model="dates"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        solo
                                        style="box-shadow:none;border-radius:0;"
                                      ></v-text-field>
                                    </template>

                                    <v-date-picker v-model="dates"
                                      :landscape="$vuetify.breakpoint.smAndUp" range></v-date-picker>
                                  </v-menu>

                                </v-col>
                                <v-col cols="12" sm="4" class="mb-3 pt-3"> 
                             
                                    <v-btn style="background: #2A3042;color: #fff;border-radius:0;" class="text-uppercase" @click="fillData(dates)">Rechercher
                                               </v-btn>
                                              
                                               </v-col>
                                <v-col cols="12" sm="12" class="mt-3 mb-3">
                                  <div class="card mini-stats-wid">
                                    <div class="card-body" style="background-color: #046089">
                                        <div class="media">
                                            <div class="media-body">
                                                <p class="font-weight-medium" style="color: white">Intervalle de recherche</p>
                                                <h4 class="mb-0" style="color: white"> {{dateRangeText}}</h4>
                                            </div>

                                            <div class="mini-stat-icon avatar-sm rounded-circle bg-white align-self-center">
                                                        <span class="avatar-title"
                                                              style="background: #00a08c!important">
                                                            <i class="bx bx-search font-size-24"></i>
                                                        </span>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                 <div class="text-center mb-4" v-if="searchloading" >
                                     <v-progress-linear
                                        color="primary"
                                        indeterminate
                                        rounded
                                        height="6"
                                      ></v-progress-linear>
                                  </div>
                              
                                </v-col>
                            </div>
                <line-chart height="150" :chart-data="datacollection"></line-chart>
                           

               </v-card>

            </div> <!-- container-fluid -->
        </div>
        <!-- End Page-content -->
</div>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import LineChart from './Chartjs/LineChart.js'

   // import $ from 'jquery';


    export default {

        name: "Home",
         components: {
            LineChart
         },
        data() {
            return {
                user: JSON.parse(localStorage.getItem("user")),
                colors: [
                    '#0098D4',
                    'warning',
                ],
                slides: [
                    '../../mineimages/slide2.jpg',
                    '../../mineimages/slide1.jpg',
                ],
                datacollection: null,
                searchloading: false,
                menu2:false,
                 dates: [new Date().getFullYear()+'-01-01', new Date().getFullYear()+'-'+((new Date().getMonth()+1)<10?'0':'')+(new Date().getMonth()+1)+'-'+((new Date().getDate())<10?'0':'')+(new Date().getDate())],
            }
        },
        computed: {
            dateRangeText () {
                return this.dates.join(' ~ ')
            },
            ...mapState('balance/', ['balance']),
            ...mapState('balance_stories/', ['sumvente']),
            ...mapState('userspharmacies/', ['userspharmacies']),
            ...mapState('precommandes/', ['precommandeCount'])
        },
        mounted() {
        window.scrollTo(0,0);
            this.fillData(this.dates)
            this.$store.dispatch('balance/get', (this.user.relation==null?null:this.user.relation._id)).then(response => {
                window.console.log('user', response)
            });
            this.$store.dispatch('balance_stories/getSumVente', (this.user.relation==null?null:this.user.relation._id)).then(response => {
                window.console.log('balance_stories', response)
            });
            let data = new FormData();
            data.append("pharmacie", (this.user.relation==null?null:this.user.relation._id));
            this.$store.dispatch('precommandes/getPrecommandeCount', data).then(response => {
                window.console.log('precommandes', response)
            });
            this.$store.dispatch('userspharmacies/getUsersPharmacie',(this.user.relation==null?null:this.user.relation._id)).then(response => {
                window.console.log('userspharmacies', response)
            });
        },
        watch: {
          '$store.state.balance_stories.searchResult': function() {
                    this.searchloading = false;
                    this.datacollection = {
                      labels: this.$store.state.balance_stories.searchResult[0],
                      datasets: [
                        {
                          label: 'Statistique des ventes',
                          backgroundColor: '#00A18F',
                          data: this.$store.state.balance_stories.searchResult[1]
                        }
                      ]
                    }
          }
        },
        methods: {
            date_sort_asc(date1, date2) {
              // This is a comparison function that will result in dates being sorted in
              // ASCENDING order. As you can see, JavaScript's native comparison operators
              // can be used to compare dates. This was news to me.
              if (date1 > date2) return 1;
              if (date1 < date2) return -1;
              return 0;
            },
          fillData (date) {
                this.dates = date.sort(this.date_sort_asc);
                this.searchloading = true;
                let data = new FormData();
                data.append("dateIntervalle", JSON.stringify(date));
                data.append("pharmacie", (this.user.relation==null?null:this.user.relation._id));
                this.$store.dispatch('balance_stories/searchVente', data).then(response => {
                    console.log(response)
                });
          },
          getRandomInt () {
            return Math.floor(Math.random() * (50 - 5 + 1)) + 5
          }
        }
    }
</script>

<style scoped>

</style>
